import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ClassService, ConfigService, ScriptLoaderService } from './../../../../../../_services';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvestorDocument } from '../../../../../../_models/investorDocument';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';


@Component({
    selector: 'app-configs-investor-document-create-modal',
    templateUrl: './configs-investor-document-create-modal.component.html',
    styles: ['.select2-search__field { with:100% !important; }']
})
export class ConfigsInvestorDocumentCreateModalComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() category_id: number;
    public model = new InvestorDocument(null, null, null, null, null, null, null);
    public errors: string[];
    //public file_types = [];

    @BlockUI() blockUI: NgBlockUI;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('errorsListSwal') private errorsListSwal: SwalComponent;

    constructor(private _configService: ConfigService,
        private _script: ScriptLoaderService,
  			      /*private _modalService: NgbModal*/) {
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this._script.loadScripts('app-configs-investor-document-create-modal', ['assets/demo/demo2/custom/crud/forms/widgets/select2.js']);
        ($('.people_type') as any).select2({
            placeholder: 'seleccione un tipo de persona'
        });
        ($('.file_type') as any).select2({
            placeholder: 'seleccione un tipo de archivo'
        });

    }

    ngOnChanges(changes: SimpleChanges) {

    }

    createInvestorDocument() {
        this.blockUI.start();
        this.model.file_types = ($('.file_type') as any).select2("val").toString();
        this.model.people_types = ($('.people_type') as any).select2("val").toString();
        this._configService.postInvestorDocument(this.model).subscribe(response => {
            this.blockUI.stop();
            this.successSwal.text = response.message;
            this.successSwal.show();

        }, error => {
            this.errors = error.error.error.errors;
            this.blockUI.stop();
            this.errorsListSwal.show();
        }, () => {

        });
    }

    reload() {
        window.location.reload();
    }

    clear() {
        this.model.name = '';
        this.model.file_types = '';
        this.model.description = '';
        this.model.people_types = '';
        this.model.required = null;
        this.model.apply_foreign = null;
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-modals/investor-document-create-modal/configs-investor-document-create-modal.component.ts